// extracted by mini-css-extract-plugin
module.exports = {"star":"AiAnimation_star__mqV_e","one":"AiAnimation_one__Zeepk","two":"AiAnimation_two___SgwK","three":"AiAnimation_three__tGiWR"};